class AkumiNavigation extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.addEventListener('toggle', event => {
      const disclosure = event.target;
      if (!(disclosure instanceof HTMLDetailsElement)) return;
      const summary = disclosure.querySelector(':scope > summary');
      summary?.setAttribute('aria-expanded', String(disclosure.open));
      if (disclosure.open && disclosure.classList.contains('akumi-navigation__disclosure')) {
        this.querySelectorAll('.akumi-navigation__disclosure[open]').forEach(other => {
          if (other !== disclosure) other.open = false;
        });
      }
    }, { capture: true, signal });
    this.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const nearest = event.target.closest('details[open]');
      const disclosure = nearest && this.contains(nearest)
        ? nearest
        : this.querySelector('.akumi-navigation__disclosure[open]')
          || this.querySelector('.akumi-navigation__mobile-menu[open]');
      if (disclosure) {
        event.preventDefault();
        event.stopPropagation();
        disclosure.open = false;
        disclosure.querySelector(':scope > summary')?.focus();
      }
    }, { signal });
    this.addEventListener('click', event => {
      if (event.target.closest('a[href]')) this.close();
    }, { signal });
    document.addEventListener('pointerdown', event => {
      if (!this.contains(event.target)) this.close();
    }, { signal });
    document.addEventListener('focusin', event => {
      if (!this.contains(event.target)) {
        this.close();
        return;
      }
      this.querySelectorAll('.akumi-navigation__disclosure[open]').forEach(disclosure => {
        if (!disclosure.contains(event.target)) disclosure.open = false;
      });
    }, { signal });
    this.breakpoint = window.matchMedia('(max-width: 1100px)');
    this.breakpoint.addEventListener('change', () => this.close(), { signal });
    this.querySelectorAll('details > summary').forEach(summary => {
      summary.setAttribute('aria-expanded', String(summary.parentElement.open));
    });
  }

  close() {
    this.querySelectorAll('details[open]').forEach(disclosure => {
      disclosure.open = false;
    });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}

if (!customElements.get('akumi-navigation')) {
  customElements.define('akumi-navigation', AkumiNavigation);
}
